import React, { useEffect } from "react";
import { Button, TextField } from "@c4c-web/ui";
import type { IAddress } from "../../../types";
import type { IFormFieldsProps } from "./AddressFormFields";

interface IAreaFormFieldProps extends IFormFieldsProps {
  address: IAddress;
}

export const AreaFormField: React.FC<IAreaFormFieldProps> = ({
  address,
  errors,
  register,
  editInfo,
  handleMapAddress,
  setIsTyping,
  setIsSelected,
  setShowMap,
  t,
  toggleForm,
}) => {
  useEffect(() => {
    if (editInfo?.id) {
      setIsTyping?.(true);
      setIsSelected?.(true);
    }
  }, [editInfo?.id, setIsTyping, setIsSelected]);

  const handleAreaChange = (): void => {
    toggleForm?.(false);
    setShowMap?.((prev) => !prev);
    if (editInfo?.id) {
      setIsTyping?.(true);
      setIsSelected?.(true);
    }
  };

  return (
    <div className="relative">
      <TextField
        defaultValue={address.emirate || address.town}
        id="area"
        label={`${t("addressJourney.addressForm.area")}*`}
        {...register("emirate")}
        disabled
        error={Boolean(errors.emirate)}
        haveBoldText
        helperText={errors.emirate ? t("addressJourney.error.area") : ""}
        placeholder={t("addressJourney.addressForm.placeHolders.area")}
      />
      <div className="absolute right-md top-1/2">
        <Button
          className="text-md"
          onClick={(e) => {
            e.preventDefault();
            handleAreaChange();
            handleMapAddress?.(address);
          }}
          variant="ghost"
        >
          {t("addressJourney.change")}
        </Button>
      </div>
    </div>
  );
};
